const instructor = [
      {
        title: 'Economics of the Public Sector: Expenditure',
        description: 'Undergrad, University of Toronto-Scarborough, 2025',
    },
    {
        links: [
            {
                title: 'F2025 Evals: 4.8/5, Response Rate: 27%',
                url: 'PublicEconomicsW2025.pdf',
                external: false
            }
        ]
    } ,
       {
        title: 'Labour Economics 1',
        description: 'Undergrad, University of Toronto-Scarborough, 2024-2025',
    },
    {
        links: [
            {
                title: 'F2024 Evals: 4.6/5, Response Rate: 50%',
                url: 'LabourEconomicsF2024.pdf',
                external: false
            }
        ]
    },
    {
        title: 'Labour Economics: Employment, Wages, and Public Policy',
        description: 'Undergrad, University of Toronto, 2021-2023',
    },
    {
        links: [
            {
                title: 'F2021 Evals: 4.7/5, Response Rate: 60%',
                url: 'LabourEconomicsF2021.pdf',
                external: false
            },
            {
                title: 'W2022 Evals: 4.7/5, Response Rate: 38%',
                url: 'LabourEconomicsW2022.pdf',
                external: false
            },
            {
                title: 'F2022 Evals: 4.7/5, Response Rate: 56%',
                url: 'LabourEconomicsF2022.pdf',
                external: false
            },
            {
                title: 'W2023 Evals: 4.5/5, Response Rate: 30%',
                url: 'LabourEconomicsW2023.pdf',
                external: false
            }



        ]
    }
]

const education = [
    {
        title: 'PhD in Economics',
        description: 'University of British Columbia, 2015 - 21'
    },
    {
        title: 'MA Economics',
        description: 'Queen\'s University, 2014 - 15'
    },
    {
        title: 'BA Economics',
        description: 'Mount Allison University, 2011 - 14'
    }
]



const researchGrants = [
    {
        title: 'Postdoctoral Fellowship',
        description: 'Social Sciences and Humanities Research Council (SSHRC), 2021 - 2023'
    },
    {
        title: 'Center for Innovative Data in Economics Grant (1)',
        description: '2019'
    },
    {
        title: 'Center for Innovative Data in Economics Grant (2)',
        description: '2019'
    },
    {
        title: 'Doctoral Award, Social Sciences and Humanities Research Council (SSHRC)',
        description: '2018 - 20'

    }
]

const awards = [
    {
        title: 'UBC Public Scholars Initiative',
        description: '2020'
    },
    {
        title: 'CRDCN Emerging Scholars Grant',
        description: '2019'
    },
    {
        title: 'Visiting Research Fellowship, Department of Finance, Canada',
        description: '2018'
    },
    {
        title: 'Albert Whiteley Memorial Fellowship, University of British Columbia',
        description: '2018'
    },
    {
        title: 'Scarthingmoor Award for Best MA Thesis, Queen\'s University',
        description: '2015'
    },
    {
        title: 'Canada Graduate Scholarship',
        description: 'SSHRC, 2014 - 15'
    }
]
const invitedPresentations = [ 
    {
        title: 'Econometric Society at ASSA',
        description: 'January 2025'
    }, 
    {
        title: 'Canadian Public Economics Group',
        description: 'November 2024'
    }, 
    {
        title: 'IRP Summer Research Workshop',
        description: 'June 2024'
    }, 
    {
        title: 'Bozeman Applied Economics Summer Conference',
        description: 'June 2024'
    }, 
    {
        title: 'Canadian Economics Association Annual Conference',
        description: 'May 2024'
    }, 
    {
        title: 'Bristol Applied Economics Meetings',
        description: 'May 2024'
    }, 
    {
        title: 'Dalhousie University',
        description: 'January 2024'
    }, 
    {
        title: 'Simon Fraser University',
        description: 'January 2024'
    },     
    {
        title: 'University of Guelph',
        description: 'January 2024'
    },       
    {
        title: 'UBC Allard Tax Policy Seminar',
        description: 'September 2023'
    },     
    {
        title: 'Canadian Economics Association',
        description: 'June 2023'
    },  
    {
        title: 'Society of Labor Economists Annual Conference',
        description: 'May 2023'
    },  
    {
        title: 'Canadian Public Economics Group Annual Conference',
        description: 'November 2022'
    },  
    {
        title: 'Banff Empirical Microeconomics Conference',
        description: 'August 2022'
    },
    {
        title: 'Canadian Economics Association',
        description: 'June 2022'
    },
    {
        title: 'Online Public Finance Seminar',
        description: 'April 2022'
    }, 
    {
        title: 'Finances of the Nation',
        description: 'December 2021'
    }, 
    {
        title: 'National Tax Association Annual Conference 2019',
        description: 'November 2019'
    },
    {
        title: 'UBC Allard Law School Tax Administration Workshop',
        description: 'October 2019'
    },
    {
        title: 'Canadian Research Data Center Network Annual Conference',
        description: 'October 2019'
    },
    {
        title: 'Oxford Doctoral Business Tax Conference',
        description: 'September 2019'
    },
    {
        title: 'Mannheim Tax Conference',
        description: 'September 2019'
    },
    {
        title: 'International Institute for Public Finance Annual Congress',
        description: 'August 2019'
    },
    {
        title: 'Canadian Economics Association',
        description: 'May 2019'
    },
    {
        title: 'American Law and Economics Association',
        description: 'May 2019'
    },
    {
        title: 'Department of Finance',
        description: 'December 2018'
    },
    {
        title: 'Employment and Social Development Canada',
        description: 'December 2018'
    },
    {
        title: 'National Tax Association Annual Conference',
        description: 'November 2018'
    },
    {
        title: 'Mount Allison University Seminar',
        description: 'October 2018'
    },
    {
        title: 'Canadian Research Data Center Network Annual Conference (Poster)',
        description: 'October 2018'
    }
]
const refereeService = [
    {
        title: '13 reports: American Economic Journal: Economic Policy, Journal of Public Economics, Journal of Urban Economics, Journal of Development Economics, Journal of Economic Dynamics and Control, Canadian Tax Journal, Canadian Public Policy, Institute for Research on Public Policy',
        description: ''
    }
]

const software = [
    {
        title: 'Python',
        description: '(for scraping)'
    },
    {
        title: 'R',
        description: '(for mapping)'
    },
    {
        title: 'Stata',
        description: ''
    },
    {
        title: 'MATLAB',
        description: '(for simulating)'
    }
]

const languages = [
    {
        title: 'English',
        description: 'Native'
    },
    {
        title: 'Spanish',
        description: 'Intermediate'
    }
]

module.exports = { instructor, education, researchGrants, awards, refereeService, invitedPresentations, software, languages }